<template lang="pug">
  div.nav-branch(:class="{ 'menu-selected': routeSelected }")
    v-layout.py-2.px-4.click.align-center(
      v-if="hasCorrectRoles && !hasChildren"
      @click="$router.push({ name: menu.route }); $emit('close'); open = false;"
    )
      span.py-2 {{ menu.title }}
    v-layout.py-2.px-4.click.align-center(
      v-else-if="hasCorrectRoles"
      @click="toggle"
    ) 
      span.py-2 {{ menu.title }}
      v-icon(v-if="!open") expand_more
      v-icon(v-else) expand_less
  //- v-list-group(v-else-if="hasCorrectRoles" :value="open")
    template(slot="activator")
      v-list-tile
        v-list-tile-title {{ menu.title }}
    rc-navigation-branch(v-for="item in menu.children" :key="item.route" :menu="item" ref="branches")
</template>

<script>
export default {
  props: {
    menu: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      open: false,
    }
  },
  methods: {
    hasSelectedRoute(menu) {
      return (menu.route === this.$route.name) || (menu.children && menu.children.some(x => this.hasSelectedRoute(x)));
    },
    toggle() {
      this.open = !this.open;
      this.$emit('toggle', this.open ? this.menu : null);
    },
  },
  computed: {
    hasChildren() {
      return this.menu.children && !!this.menu.children.length;
    },
    hasCorrectRoles() {
      return !this.menu.permissions || !this.menu.permissions.length || this.menu.permissions.every(it => !!this.$store.state.app.user.roles.find(x => x.name === it));
    },
    routeSelected() {
      return !!this.$route.matched.find(it => {
        return this.menu.route === it.name;
      });
    }
  },
};
</script>

<style lang="scss" scoped>
  .menu-selected {
    // background-color: var(--primary);
    background-color: #efefef;
    // color: white;
  }
  .nav-branch {
    i {
      transition: none;
    }
    &:not(.menu-selected):hover {
      color: white;
      background-color: var(--primary);
      i {
        color: white;
      }
    }
  }
</style>


